/**
 * Dev timing for classic / LiB search RPCs (FeedOptimised).
 * Enable from FeedOptimised while a searchbar query is active; logs only when on.
 */

let enabled = false;
let searchSession = 0;

export function setSearchRpcTimingEnabled(on: boolean) {
  if (on && !enabled) {
    searchSession += 1;
    console.log(
      `%c[lib-search]#${searchSession} timing ON`,
      "color:#0a7;font-weight:bold",
    );
  }
  if (!on && enabled) {
    console.log(
      `%c[lib-search]#${searchSession} timing OFF`,
      "color:#888;font-weight:bold",
    );
  }
  enabled = on;
}

export function isSearchRpcTimingEnabled() {
  return enabled;
}

export async function timeSearchRpc<T>(
  label: string,
  fn: () => Promise<T>,
  meta?: Record<string, unknown>,
): Promise<T> {
  if (!enabled) return fn();
  const tag = `[lib-search]#${searchSession}`;
  const t0 = performance.now();
  const metaStr = meta
    ? ` ${JSON.stringify(meta)}`
    : "";
  console.log(`${tag} ▶ ${label}${metaStr}`);
  try {
    const result = await fn();
    const ms = Math.round(performance.now() - t0);
    let extra = "";
    if (Array.isArray(result)) {
      extra = ` rows=${result.length}`;
    } else if (result && typeof result === "object") {
      const r = result as Record<string, unknown>;
      if (typeof r.feedCount === "number") extra += ` feedCount=${r.feedCount}`;
      if (Array.isArray(r.postIds)) extra += ` ids=${r.postIds.length}`;
      if (typeof r.totalPages === "number") extra += ` pages=${r.totalPages}`;
    }
    console.log(`${tag} ✓ ${label} ${ms}ms${extra}`);
    return result;
  } catch (err) {
    const ms = Math.round(performance.now() - t0);
    console.log(`${tag} ✗ ${label} ${ms}ms`, err);
    throw err;
  }
}
